"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.msToHours = msToHours;
exports.hoursToMs = hoursToMs;
exports.msToDays = msToDays;
exports.daysToMs = daysToMs;
var HOURS_TO_MS_MULT = 60 * 60 * 1000;
var DAYS_TO_MS_MULT = 24 * HOURS_TO_MS_MULT;

function msToHours(ms) {
  return ms / HOURS_TO_MS_MULT;
}

function hoursToMs(hours) {
  return hours * HOURS_TO_MS_MULT;
}

function msToDays(ms) {
  return ms / DAYS_TO_MS_MULT;
}

function daysToMs(days) {
  return days * DAYS_TO_MS_MULT;
}